import Heading from "components/Heading/Heading";
import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import VectorImg from "images/VectorHIW.svg";
import hiw1 from "images/home/hiw1.png";
import hiw2 from "images/home/hiw2.png";
import hiw3 from "images/home/hiw3.png";

export interface SectionHowItWorkProps {
  className?: string;
}

const DEMO_DATA = [
  {
    id: 1,
    img: hiw1,
    title: "Mudah Cari Barang yang Pas",
    desc: "Daripada ribet cek toko sewa satu-satu, disini kamu bisa cari barang dengan berbagai filter!",
  },
  {
    id: 2,
    img: hiw2,
    title: "Berbagai Lokasi",
    desc: "Enggak perlu ribet bawa barang! kamu bisa sewa di lokasi terdekat di seluruh wilayah Bali",
  },
  {
    id: 3,
    img: hiw3,
    title: "Banyak Promo",
    desc: "Makin sering kamu sewa disini, makin banyak potongan harga yang bisa kamu dapetin!",
  },
];

const SectionHowItWork: FC<SectionHowItWorkProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHowItWork  ${className}`}
      data-nc-id="SectionHowItWork"
    >
      <Heading isCenter desc="">
        Kenapa Sewa di Rentrips?
      </Heading>
      <div className="mt-20 relative grid md:grid-cols-3 gap-20">
        <img
          className="hidden md:block absolute inset-x-0 top-10"
          src={VectorImg}
          alt=""
        />
        {DEMO_DATA.map((item) => (
          <div
            key={item.id}
            className="relative flex flex-col items-center max-w-xs mx-auto"
          >
            <NcImage
              containerClassName="mb-8 max-w-[200px]  mx-auto"
              src={item.img}
              className="rounded-lg w-auto"
            />
            <div className="text-center mt-auto">
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
                {item.desc}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWork;
